<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding-left: 10px; padding-right: 10px;">

                <div class="row mb-32 gy-8 dash-top">

                    <!-- NOTI -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8" style="z-index: 9; padding-bottom: 1000px; ">

                                <!-- <h2 class="mm-none" ></h2> -->
                                <h2 class="dd-none" style="margin-top: -20px;"></h2>

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" style="overflow-x:auto;
                                flex-wrap:nowrap; scrollbar-width: none; margin-top: -10px;">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="all-tab" data-bs-toggle="tab" data-bs-target="#all"  role="tab" aria-controls="all" aria-selected="true" style="cursor: pointer;">All</h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="users-tab" data-bs-toggle="tab" data-bs-target="#users"  role="tab" aria-controls="users" aria-selected="false" style="cursor: pointer;">Follows</h6>
                                    </li>
                                            
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="tips-tab" data-bs-toggle="tab" data-bs-target="#tips"  role="tab" aria-controls="tips" aria-selected="false" style="cursor: pointer;">Tips</h6>
                                    </li>
                                    
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="subs-tab" data-bs-toggle="tab" data-bs-target="#subs"  role="tab" aria-controls="subs" aria-selected="false" style="cursor: pointer;">Subscriptions</h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="comments-tab" data-bs-toggle="tab" data-bs-target="#comments"  role="tab" aria-controls="comments" aria-selected="false" style="cursor: pointer;">Comments</h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="likes-tab" data-bs-toggle="tab" data-bs-target="#likes"  role="tab" aria-controls="likes" aria-selected="false" style="cursor: pointer;">Likes</h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="bookmarks-tab" data-bs-toggle="tab" data-bs-target="#bookmarks"  role="tab" aria-controls="bookmarks" aria-selected="false" style="cursor: pointer;">Bookmarks</h6>
                                    </li>

                                
                                </ul>

                                <!-- TAB CONTENT -->
                                <div  class="tab-content" id="allTabContent">
                                    <!-- ALL -->
                                    <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                                        

                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px; " v-for="noti in allList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >

                                                                        

                                                                    </div>

                                                                    <!-- TAGS -->
                                                                    <img class="imSize" v-if="noti.category == 'Users'" src="../assets/img/follow.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img class="imSize" v-if="noti.category == 'Subs'" src="../assets/img/subs.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img class="imSize" v-if="noti.category == 'Tips'" src="../assets/img/tips.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img class="imSize" v-if="noti.category == 'Comments'" src="../assets/img/comments.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img  class="imSize" v-if="noti.category == 'Likes'" src="../assets/img/likes.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img class="imSize" v-if="noti.category == 'Bookmarks'" src="../assets/img/bookmarks.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <img class="imSize" v-if="noti.category == 'Paid posts'" src="../assets/img/paid.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span style="margin-left: 5px;" class="mm-none">@{{ noti.userName }}</span>
                                                                        </div>

                                                                        
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyAll2">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyAll">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>


                                    <!-- users -->
                                    <div class="tab-pane fade" id="users" role="tabpanel" aria-labelledby="users-tab">
                                        
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in usersList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize" v-if="noti.category == 'Users'" src="../assets/img/follow.png" alt="" style="width: 30px; height: 30px; margin-left: -25px;">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyUsers2">

                                            <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyUsers">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>
                                        

                                    </div>

                                    <!-- TIPS -->
                                    <div class="tab-pane fade" id="tips" role="tabpanel" aria-labelledby="tips-tab">
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in tipsList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize"  src="../assets/img/tips.png" alt="" style="width: 30px; height: 30px; margin-left: -25px;">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyTips2">

                                            <InfiniteLoading @infinite="handleInfinite3" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyTips">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>

                                    <!-- SUBS -->
                                    <div class="tab-pane fade" id="subs" role="tabpanel" aria-labelledby="subs-tab">
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in subsList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize"  src="../assets/img/subs.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptySubs2">

                                            <InfiniteLoading @infinite="handleInfinite4" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptySubs">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>

                                    <!-- COMMENTS -->
                                    <div class="tab-pane fade" id="comments" role="tabpanel" aria-labelledby="comments-tab">
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in commentsList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize"  src="../assets/img/comments.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyComments2">

                                            <InfiniteLoading @infinite="handleInfinite5" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyComments">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>

                                    <!-- LIKES -->
                                    <div class="tab-pane fade" id="likes" role="tabpanel" aria-labelledby="likes-tab">
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in likesList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize"  src="../assets/img/likes.png" alt="" style="width: 30px; height: 30px; margin-left: -25px;">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyLikes2">

                                            <InfiniteLoading @infinite="handleInfinite6" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyLikes">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>

                                    <!-- BOOKMARKS -->
                                    <div class="tab-pane fade" id="bookmarks" role="tabpanel" aria-labelledby="bookmarks-tab">
                                        
                                        <div class="card hp-project-ecommerce-table-card" style="margin-bottom: 10px;" v-for="noti in bookmarksList" :key="noti.id">
                                                    <div class="card-body">
                                                        <div class="row">

                                                            <div class="col-12">

                                                                <div style="display: flex; justify-content: flex-start; align-items: flex-start; width: 100%; padding-top: 10px; cursor: pointer;" @click="profileClick(noti.userId, noti.userName)">
                                                                    
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle notiImg" >
                                                                        <img :src="noti.profilePic"  class="hp-img-cover notiImg" style=" background-color: black; border-color: black; border-width: 1px; border-style: solid; object-fit: cover;" >
                                                                    </div>

                                                                    <img class="imSize"  src="../assets/img/bookmarks.png" alt="" style="width: 30px; height: 30px; margin-left: -25px; ">

                                                                    <div style="margin-left: 20px;">
                                                                        
                                                                        <div class="d-flex">
                                                                            <h5>{{ noti.fullName }}</h5> <span class="mm-none" style="margin-left: 5px;">@{{ noti.userName }}</span>
                                                                        </div>
                                                                        
                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                <p class="bdy-left mm-none" style="margin-top: -45px; "> {{ noti.description }} </p>

                                                                <p class="bdy-left dd-none" style="margin-top: -35px; "> {{ noti.description }} </p>

                                                                <p style=" margin-top: 10px; font-weight: 400;" class="hp-d-block hp-input-description date-left"> {{ noti.dateFull }} </p>

                                                            
                                                

                                                            </div>

                                                            


                                                        </div>
                                                    </div>
                                        </div>

                                        

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyBookmarks2">

                                            <InfiniteLoading @infinite="handleInfinite7" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyBookmarks">
                                            <p class="hp-badge-text">No notifications yet...</p>
                                        </div>

                                    </div>


                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <SuggestionsBody/>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>

                <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    
</template>

<style scoped>

    .imSize{
        margin-top: 50px;
    }

    @media only screen and (max-width: 666px){

        .imSize{
            margin-top: 35px;
        }

    }

</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, serverTimestamp, orderBy, limit, startAfter } from "firebase/firestore"; 
    import {getAuth} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",

                lastDocSnapshot: null,
                lastDocSnapshot2: null,
                lastDocSnapshot3: null,
                lastDocSnapshot4: null,
                lastDocSnapshot5: null,
                lastDocSnapshot6: null,
                lastDocSnapshot7: null,

                allList: [],
                usersList: [],
                tipsList: [],
                subsList: [],
                commentsList: [],
                likesList: [],
                bookmarksList: [],
            }
        },

        mounted(){

            
            document.body.style.overflowY = 'scroll';
            document.body.style.overflowX = 'hidden';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Notifications';

            
            document.getElementById("notiN").classList.add("active");
            
            document.getElementById("notiN2").classList.add("active");
            
            this.updateCount();
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            profileClick(userId, userName){

                const auth = getAuth();

                if(auth.currentUser.uid == userId){
                    this.$router.push({name: 'profile'});
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({name: 'other-profile', params: { id: userName } });
                return;

            },

            async updateCount(){

                const auth = getAuth();
                const userRef = doc(db, "Users", auth.currentUser.uid);

                await updateDoc(userRef, {
                    notiCount: 0,
                });

            },

            async getAll(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid), orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        this.allList.push(result);

                    })

                    
                }

                return res.length;

            },

            async getUsers(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot2 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Users"){
                            this.usersList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async getTips(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot3 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot3 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Tips"){
                            this.tipsList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async getSubs(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot4 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot4 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Subs"){
                            this.subsList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async getComments(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot5 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot5 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Comments"){
                            this.commentsList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async getLikes(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot6 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot6 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Likes"){
                            this.likesList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async getBookmarks(){

                const auth = getAuth();

                let res = [];
                const q = query(collection(db, "UserNoti"), where('ownerId', '==', auth.currentUser.uid),  orderBy("dateN"), limit(10), startAfter(this.lastDocSnapshot7 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot7 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().date.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().date.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            ownerId: doc.data().ownerId,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username, 
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            
                            postId: doc.data().postId,
                            category: doc.data().category,
                            description: doc.data().description,
                            dateFull: a2.slice(0, -36),
                            
                        }

                        if(doc.data().category == "Bookmarks"){
                            this.bookmarksList.push(result);
                        }

                    })

                    
                }

                return res.length;

            },

            async handleInfinite($state){

                const newPostCount = await this.getAll();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.allList.length == 0){
                        document.getElementById("emptyAll").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyAll2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite2($state){

                const newPostCount = await this.getUsers();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.usersList.length == 0){
                        document.getElementById("emptyUsers").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyUsers2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite3($state){

                const newPostCount = await this.getTips();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.tipsList.length == 0){
                        document.getElementById("emptyTips").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyTips2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite4($state){

                const newPostCount = await this.getSubs();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.subsList.length == 0){
                        document.getElementById("emptySubs").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptySubs2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite5($state){

                const newPostCount = await this.getComments();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.commentsList.length == 0){
                        document.getElementById("emptyComments").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyComments2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite6($state){

                const newPostCount = await this.getLikes();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.likesList.length == 0){
                        document.getElementById("emptyLikes").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyLikes2").style.display = "none";
                    return $state.complete();

                    

            },

            async handleInfinite7($state){

                const newPostCount = await this.getBookmarks();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.bookmarksList.length == 0){
                        document.getElementById("emptyBookmarks").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyBookmarks2").style.display = "none";
                    return $state.complete();

                    

            },

        },
        
    }

</script>